import { USER_LIGHTBOX } from '../constants/actionTypes';

const setLightbox = (lightbox) => ({
    type: USER_LIGHTBOX,
    lightbox,
  });

export default setLightbox;
